var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"fireAlarm"}},[_c('div',{attrs:{"id":"map"}}),_c('div',{style:(_vm.scannerShow? 'transform: translateY(2000px);transition: transform 4s;':''),attrs:{"id":"scanner"}}),(_vm.share)?_c('TopShareBar'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }